import React from 'react';
import { useParams } from 'react-router-dom';
import Tarot from '../components/tarot_component/Tarot'


const Tirada = () => {
 const { signo } = useParams(); // Obtener el signo desde la URL

  return (
    <div className="App">
      <Tarot  sign={signo}/>
    </div>
  );
};

export default Tirada;